<template>
  <div>
    <div class="step_box">
      <invite-step :active="step"></invite-step>
    </div>
    <form0 v-show="step==0" @nextStep="nextStep"></form0>
    <form1 v-show="step==1" @nextStep="nextStep" @lastStep="lastStep"></form1>
    <form2 v-show="step==2" @nextStep="nextStep" @lastStep="lastStep"></form2>
    <form3 v-show="step==3" @nextStep="nextStep" @lastStep="lastStep" :step="step"></form3>
    <help-form v-show="step==4" @nextStep="nextStep" @lastStep="lastStep"></help-form>
    <result v-show="step==5" @nextStep="nextStep" @lastStep="lastStep"></result>
  </div>
</template>
<script>
import InviteStep from "./step"
import form0 from "./form0"
import form1 from "./form1"
import form2 from "./form2"
import form3 from "./form3"
import HelpForm from "./helpForm"
import result from "./result"
export default {
  data(){
    return{
      step: 0,
    }
  },
  components:{
    InviteStep,
    form0,
    form1,
    form2,
    form3,
    HelpForm,
    result
  },
  methods:{
    nextStep(){
      this.step += 1;
    },
    lastStep(){
      this.step -= 1;
    }
  }
}
</script>
<style lang="scss" scoped>
.step_box{
  margin: 20px 20px 20px 20px;
  text-align: center;
}

</style>